import { render, staticRenderFns } from "./InsightsDetails.vue?vue&type=template&id=20cd237c"
import script from "./InsightsDetails.vue?vue&type=script&lang=js"
export * from "./InsightsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports